import { AfterViewInit, Component, Inject, ViewChild } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { firstValueFrom } from 'rxjs';
import { PromptAI, PromptAIService } from 'src/app/services/promptAI/prompt-ai.service';
import { TipoElemento, UtilityService } from 'src/app/services/utility/utility.service';
import { SpinnerOverlayComponent } from '../spinner-overlay/spinner-overlay.component';

@Component({
  selector: 'app-dialog-prompt-ai',
  standalone: false,

  templateUrl: './dialog-prompt-ai.component.html',
  styleUrl: './dialog-prompt-ai.component.scss',
})
export class DialogPromptAiComponent implements AfterViewInit {
  @ViewChild(SpinnerOverlayComponent) spinnerOver!: SpinnerOverlayComponent;

  promptAI = new FormGroup({
    id: new FormControl<string | null>(null, { nonNullable: false }),
    dataUltimaModifica: new FormControl<string>('', { nonNullable: true }),
    prompt: new FormControl<string>('', { nonNullable: true }),
    idElemento: new FormControl<string>('', { nonNullable: true }),
    tipo: new FormControl<TipoElemento | undefined>(undefined, { nonNullable: true }),
    generale: new FormControl<boolean>(false, { nonNullable: true }),
  });
  constructor(
    public dialogRef: MatDialogRef<DialogPromptAiComponent>,
    private readonly _promptAIService: PromptAIService,
    private readonly _utilityService: UtilityService,

    @Inject(MAT_DIALOG_DATA)
    public data: {
      tipoElemento: TipoElemento;
      idElemento: string;
    },
  ) {}

  ngAfterViewInit(): void {
    this._init();
  }

  private _init() {
    this.promptAI.get('idElemento')?.setValue(this.data.idElemento);
    this.promptAI.get('tipo')?.setValue(this.data.tipoElemento);

    this._mapForm();
  }

  private async _mapForm(): Promise<void> {
    const promptAI = await this.getPromptByIdTipoElem();

    if (!promptAI) {
      return;
    }

    // Mappo la form
    Object.keys(promptAI).forEach((key) => {
      const control = this.promptAI.get(key as keyof PromptAI);
      if (control) {
        const value = promptAI[key as keyof PromptAI];
        control.setValue(value ?? '');
      }
    });
  }

  /**
   * Recupera il prompt AI in base a id elemento e tipo,
   * e aggiorna i controlli del FormGroup `promptAI` con i valori ottenuti.
   */
  /**
   * Recupera il prompt AI in base a id elemento e tipo,
   * e aggiorna i controlli del FormGroup `promptAI` con i valori ottenuti.
   */
  private async getPromptByIdTipoElem(): Promise<PromptAI | false> {
    const form = this.promptAI.getRawValue();
    if (!form.idElemento || !form.tipo) {
      return false;
    }

    this.spinnerOver.show();

    try {
      const result: PromptAI = await firstValueFrom(
        this._promptAIService.getPromptByIdTipoElem(form.idElemento, form.tipo),
      );
      return result;
    } catch (error: any) {
      const exceptionCode = error?.error?.exceptionCode;

      if (exceptionCode !== 'ELEMENTO_NON_TROVATO_PARAMS') {
        this._utilityService.openSnackBar(
          error?.error?.message ?? 'Errore nel reperimento del prompt',
          '',
          { duration: 2000, panelClass: ['red-snackbar'] },
        );
        return false;
      }
      return false;
    } finally {
      this.spinnerOver.hide();
    }
  }

  /**
   * Salvataggio del prompt
   */
  async salva() {
    this.spinnerOver.show();

    const promptAI: PromptAI = this.promptAI.getRawValue();

    try {
      const result = await this._promptAIService.salva(promptAI);
      if (result) {
        this.dialogRef.close();
      }
    } catch (error) {
      console.error(error);
    } finally {
      this.spinnerOver.hide();
    }
  }
}
